/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Aside_Reply_BodyInputs */

const en_contact_aside_reply_body = /** @type {(inputs: Contact_Aside_Reply_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usually within one working day, in English or Polish.`)
};

const pl_contact_aside_reply_body = /** @type {(inputs: Contact_Aside_Reply_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwykle w ciągu jednego dnia roboczego, po polsku lub angielsku.`)
};

/**
* | output |
* | --- |
* | "Usually within one working day, in English or Polish." |
*
* @param {Contact_Aside_Reply_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_aside_reply_body = /** @type {((inputs?: Contact_Aside_Reply_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Aside_Reply_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_aside_reply_body(inputs)
	return en_contact_aside_reply_body(inputs)
});